import React from 'react';
import { string, oneOf } from 'prop-types';
import { Link } from 'gatsby';
import Button from 'react-bootstrap/Button';
import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';

import Card from '../Card/Card';
import Hexagon from '../Hexagon/Hexagon';

const propTypes = {
  slug: string,
  title: string.isRequired,
  text: string.isRequired,
  link: string.isRequired,
  label: string,
  color: oneOf([
    'primary',
    'secondary',
    'green',
    'blue',
    'orange',
    'red',
    'dark-green',
  ]),
};

const defaultProps = {
  slug: null,
  label: 'Read More',
  color: 'primary',
};

const categoryColorMap = {
  'case-studies': 'dark-green',
  infographics: 'green',
  'issue-briefs': 'primary',
  publications: 'orange',
  research: 'red',
  topics: 'blue',
  'videos-podcasts': 'secondary',
  'white-papers': 'primary',
};

const getCategoryColor = (slug) => {
  const categorySlug = String(slug).toLocaleLowerCase();
  return categoryColorMap[categorySlug];
};

const textColorMap = {
  primary: 'text-primary',
  secondary: 'text-info',
  green: 'text-green',
  blue: 'text-blue',
  orange: 'text-orange',
  red: 'text-red',
  'dark-green': 'text-dark-green',
};

const CardResource = ({ slug, title, text, link, label, color }) => {
  const cardColor = getCategoryColor(slug) || color;
  const textClasses = textColorMap[cardColor];

  const buttonExternal = String(link).startsWith('http');
  const buttonClasses = `fw-bold text-decoration-none ps-0 d-flex align-items-center ${textClasses}`;
  const buttonProps = buttonExternal
    ? { as: 'a', href: link }
    : { as: Link, to: link };
  const buttonLabel = slug === 'videos-webinars' ? 'Watch Today' : label;

  return (
    <Card color={cardColor} bordered className="c-card-resource bg-dark">
      <Card.Header>
        <Card.Title>
          <Card.Icon>
            <Hexagon className={textClasses} />
          </Card.Icon>
          <h6 className={textClasses}>
            <strong>{title}</strong>
          </h6>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <p>{text}</p>
      </Card.Body>
      <Card.Action>
        <Button variant="link" className={buttonClasses} {...buttonProps}>
          {buttonLabel}
          <IoIosArrowForward className="ms-1" />
        </Button>
      </Card.Action>
    </Card>
  );
};

CardResource.propTypes = propTypes;
CardResource.defaultProps = defaultProps;

export default CardResource;
